import { ColDef, ColGroupDef } from "@ag-grid-community/core";
import { inject, Injectable } from "@angular/core";
import { CellRendererParams, getMetricsColDef as getMetricsColDefM19Service } from "@front/m19-grid-config";
import { Metric } from "@front/m19-metrics";
import { TranslocoService } from "@jsverse/transloco";
import { IMetricEvoGridComponent } from "@front/m19-ui";
import { MetricDescriptionPipe, MetricTitlePipe } from "@front/m19-utils";

@Injectable({
  providedIn: "root",
})
export class GridConfigService {
  private readonly translocoService = inject(TranslocoService);
  private readonly metricTitlePipe = inject(MetricTitlePipe);
  private readonly metricDescriptionPipe = inject(MetricDescriptionPipe);

  getMetricsColDef<T>(
    metrics: Metric<T>[],
    groupMetric = false,
    getContext: (data: T) => CellRendererParams = () => ({}),
  ): ColGroupDef<T>[] {
    return getMetricsColDefM19Service(metrics, groupMetric, IMetricEvoGridComponent, getContext).map(
      (def: ColGroupDef<T>) => {
        const colDef = def as ColDef<T>;
        return {
          ...def,
          headerName: colDef.colId
            ? this.metricTitlePipe.transform(colDef.colId)
            : this.translocoService.translate(`${def.headerName}`),
          headerValueGetter: () => {
            return colDef.colId
              ? this.metricTitlePipe.transform(colDef.colId)
              : this.translocoService.translate(`${def.headerName}`);
          },
          headerTooltip:
            def.headerTooltip || colDef.colId
              ? colDef.colId
                ? this.metricDescriptionPipe.transform(colDef.colId)
                : this.translocoService.translate(`${def.headerName}`)
              : "",
        };
      },
    );
  }
}
